export interface MarketWithTypeKey {
  '1x2'?: Market | null;
  FIRST_HALF?: Market | null;
  SECOND_HALF?: Market | null;
  FULL_TIME?: Market | null;
  12?: Market | null;
  OVER_UNDER?: Market | null;
  DOUBLE_CHANCE?: Market | null;
  BOTH_TO_SCORE?: Market | null;
  DRAW_NO_BET?: Market | null;
  FIRST_TEAM_TO_SCORE?: Market | null;
  GAME_HANDICAP?: Market | null;
  FIRST_HALF_GOALS?: Market | null;
  CORRECT_SCORE?: Market | null;
  FIRST_PLAYER_TO_SCORE?: Market | null;
  PLAYER_TO_SCORE_DURING_GAME?: Market | null;
  PLAYER_TO_RECEIVE_CARD?: Market | null;
  FIRST_HALF_AND_FINAL_RESULT?: Market | null;
}

export interface Market {
  type: MarketType;
  scope: ScopeType;
  selections: Selection[];
}

interface MarketType {
  id: string;
  name: string | null;
  code: string | null;
  entity_type: string;
}

interface ScopeType {
  id: string;
  name: string | null;
  type: string;
  entity_type: string;
}

export interface Selection {
  name: string | null;
  code: string | null;
  additional_info: SelectionAdditionalInfo | null;
  entity_type: string | null;
  movement: Movement | null;
  odds: string | null;
  odds_old: string | null;
  value: string | null;
  urls: SelectionUrl[] | null;
}

interface SelectionAdditionalInfo {
  name: string | null;
  pending: boolean;
}

interface SelectionUrl {
  app_type: string | null;
  url: string | null;
}

export declare enum Movement {
  UP = 'UP',
  DOWN = 'DOWN',
  NONE = 'NONE',
}

export enum ScopeTypes {
  FIRST_HALF = 'FIRST_HALF',
  SECOND_HALF = 'SECOND_HALF',
  ORDINARY_TIME = 'ORDINARY_TIME',
  FULL_TIME = 'FULL_TIME',
  ALL = 'ALL',
}
